package fyi.moko.hotpl.service

import fyi.moko.hotpl.domain.service.ConnectivityObserver
import kotlinx.coroutines.channels.awaitClose
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.callbackFlow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.browser.window
import org.w3c.dom.events.Event

class JsConnectivityObserver : ConnectivityObserver {

    override val isOnline: Flow<Boolean> = callbackFlow {
        val initialStatus = try {
            window.navigator.onLine
        } catch (e: Exception) {
            true
        }
        trySend(initialStatus)

        val onlineListener = { _: Event -> trySend(true); Unit }
        val offlineListener = { _: Event -> trySend(false); Unit }

        window.addEventListener("online", onlineListener)
        window.addEventListener("offline", offlineListener)

        awaitClose {
            window.removeEventListener("online", onlineListener)
            window.removeEventListener("offline", offlineListener)
        }
    }.distinctUntilChanged()
}
